/**
 * A server timestamp as epoch milliseconds.
 *
 * The server stores UTC. Some of its messages sent the time without a zone
 * ("2026-10-27T08:00:00"), which a browser reads as local time - so in India a
 * conversation updated just now showed as "5h ago" and sorted below older
 * ones. A date-time with no zone is therefore taken as UTC.
 */
export const serverTime = (iso) => {
  if (!iso) return NaN;
  const text = String(iso);
  const hasZone = /(?:Z|[+-]\d{2}:?\d{2})$/i.test(text);
  return new Date(hasZone || !text.includes("T") ? text : `${text}Z`).getTime();
};

export default serverTime;
